import { DASHBOARDS_LEARNING_PAGE_KEY } from './constants';
import type { TTranslations } from './types';

// TODO: l10n review — translations are functional equivalents of the Spanish source
export const pt: TTranslations = {
  [DASHBOARDS_LEARNING_PAGE_KEY]: {
    PAGE_TITLE: 'Aprendizado',
    PAGE_SUBTITLE:
      'Visualize o consumo da plataforma de aprendizado. Cursos próprios vs catálogo Crehana, evolução trimestral, certificações e satisfação.',
    NEW_TAG: 'Novo',
    FRESHNESS_PREFIX: 'Última atualização:',
    FRESHNESS_DATE: '14 mai, 09:00 AM',
    PRODUCT_SELECTOR_LABEL: 'Produto',
    PRODUCT_SELECTOR_HELPER: 'Selecione o produto que deseja analisar',
    PRODUCT_GENERAL: 'Geral',
    PRODUCT_LEARNING: 'Aprendizado',
    BREADCRUMB_ROOT: 'Analytics Hub',
    BREADCRUMB_DASHBOARDS: 'Dashboards',
    BREADCRUMB_LEARNING: 'Aprendizado',
    TAB_GENERAL: 'Geral',
    TAB_PATHS: 'Por trilhas',
    TAB_COURSES: 'Por cursos',
    TAB_USERS: 'Por usuários',
    TAB_PLACEHOLDER_PATHS: 'Conteúdo de trilhas em breve',
    TAB_PLACEHOLDER_COURSES: 'Conteúdo de cursos em breve',
    TAB_PLACEHOLDER_USERS: 'Conteúdo de usuários em breve',
    EMPTY_TITLE: 'Nenhum módulo disponível',
    EMPTY_DESCRIPTION: 'Quando houver dados de aprendizado, você os verá aqui.',
    ERROR_TITLE: 'Erro ao carregar o dashboard',
    ERROR_RETRY: 'Tentar novamente',
    CERT_SECTION_TITLE: 'Certificados',
    CERT_SECTION_DESC:
      'Um certificado é emitido quando um usuário conclui um curso com certificação habilitada. Um mesmo usuário pode obter múltiplos certificados (um por curso concluído).',
    HISTORIC_CHIP: 'Histórico · não depende do período',
    CERT_KPI_TOTAL_LABEL: 'Certificados emitidos (total)',
    CERT_KPI_USERS_LABEL: 'Usuários com pelo menos 1 certificado',
    CERT_KPI_AVG_LABEL: 'Média de certificados por usuário',
    CERT_CHART_TITLE: 'Certificados emitidos por mês',
    CERT_CHART_HELPER: 'Últimos 16 meses · Certificados emitidos por mês',
    CERT_CHART_BARS_LEGEND: 'Certificados',
    CSAT_SECTION_TITLE: 'Satisfação das Pesquisas — Rotas principais',
    CSAT_TABLE_TITLE: 'Satisfação das pesquisas por rota principal',
    CSAT_COL_ROUTE: 'Rota',
    CSAT_COL_SCORE: 'CSAT (1–5)',
    CSAT_COL_SCORE_TOOLTIP:
      'Média do CSAT dos cursos da rota. Diferente do rating individual de curso do bloco de métricas-chave.',
    CSAT_COL_RESPONSES: 'Respostas',
    CSAT_COL_UNIQUE_USERS: 'Usuários únicos',
    CSAT_SCORE_SUFFIX: '/5',
    CSAT_EMPTY_TITLE: 'Sem rotas principais',
    CSAT_EMPTY_DESC: 'Nenhuma rota lançada nos últimos 90 dias.',
    CSAT_ERROR_TITLE: 'Erro ao carregar dados de CSAT',
    CSAT_ERROR_RETRY: 'Tentar novamente',
  },
};
